import Transition from "./Transition.js"
import gsap from 'gsap'

export default class DefaultTransition extends Transition {

	constructor() {

		super( {

			sync: true

		} )

	}

	leave( { current } ) {

		const timeline = gsap.timeline()

		timeline.to( current.container, {

			autoAlpha: 0

		} )

		return timeline

	}

	enter( { next } ) {

		const timeline = gsap.timeline()


		timeline.fromTo( next.container, {

			autoAlpha: 0

		}, {

			autoAlpha: 1

		} )

		return timeline

	}

}
